<template>
  <input v-if="!multiline" :type="type" :class="classes" v-model="model" v-bind="$attrs" />
  <textarea v-else :class="classes" v-model="model" v-bind="$attrs" />
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    type?: 'text' | 'email' | 'number' | 'url'
    error?: boolean
    valid?: boolean
    multiline?: boolean
  }>(),
  {
    type: 'text'
  }
)

const model = defineModel<string>()

const classes = computed(() => [
  'block',
  'w-full',
  'mb-3',
  'rounded',
  'bg-white border',
  'border-primary-100',
  'text-primary',
  'placeholder:text-primary-200',
  '[&:is(.error)]:border-danger',
  '[&:is(.error)]:outline-danger',
  '[&:is(.error)]:shadow-none',
  '[&:is(.valid)]:border-success',
  '[&:is(.valid)]:outline-success',
  '[&:is(.valid)]:shadow-none',
  { error: props.error, valid: props.valid }
])
</script>
